'use client'

import ProductCardImage from '../product-card-image'
import { handeOnClickProduct } from './utils'
import type { Props } from './product-card-gallery'

type PictureProps = {
  product: Props['product']
  ticket: Props['ticket']
  imageWidth?: number
  imageHeight?: number
  imagePriority?: Props['imagePriority']
  digitalDataIndex: Props['digitalIndex']
  digitalDataOrigin: Props['digitalDataOrigin']
  className?: string
  productImageUrlOverride?: string
}
const Picture = ({
  product,
  ticket,
  imageWidth,
  imageHeight,
  imagePriority,
  digitalDataIndex,
  digitalDataOrigin,
  className,
  productImageUrlOverride,
}: PictureProps) => {
  return (
    <ProductCardImage
      product={product}
      ticket={ticket}
      onClickProduct={() => handeOnClickProduct(digitalDataOrigin, product, digitalDataIndex)}
      imageWidth={imageWidth}
      imageHeight={imageHeight}
      priority={imagePriority}
      className={className}
      useAnchorTag={true}
      productImageUrlOverride={productImageUrlOverride}
    />
  )
}
export default Picture
